import { Form, Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import DaysSelector from "./DaySelector";

const RequirementsSelector = ({ formData, setFormData, errors }) => {
  // console.log(errors);
  // const daysOptions = [
  //   { label: "2 days", value: 2 },
  //   { label: "3 days", value: 3 },
  //   { label: "5 days", value: 5 },
  // ];

  const timingOptions = [
    { label: "7:30am - 8:00pm", value: "7:30am", end: "8:00pm" },
    { label: "8:00am - 1:00pm", value: "8:00am", end: "1:00pm" },
    { label: "8:00am - 2:00pm", value: "8:00am", end: "2:00pm" },
    { label: "8:00am - 3:00pm", value: "8:00am", end: "3:00pm" },
    { label: "8:00am - 4:00pm", value: "8:00am", end: "4:00pm" },
    { label: "8:00am - 5:00pm", value: "8:00am", end: "5:00pm" },
  ];

  // const handleDayChange = (value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     num_of_days: value,
  //   }));
  // };

  const handleTimeChange = (start, end) => {
    const formattedTime = `${start} - ${end}`;
    setFormData((prev) => ({
      ...prev,
      attending_times: [{ time: formattedTime }],
    }));
  };

  return (
    <div>
      <Row>
        <Col md={6}>
          <DaysSelector
            formData={formData}
            setFormData={setFormData}
            errors={errors}
          />
        </Col>
        {/* <Col md={6}>
          <Form.Label>
            <strong>Number of days per week</strong>
          </Form.Label>
          {daysOptions.map((day) => (
            <Form.Check
              key={day.value}
              type="radio"
              name="noOfDays"
              id={`noOfDays_${day.value}`}
              label={day.label}
              value={day.value}
              checked={formData.num_of_days === day.value}
              onChange={() => handleDayChange(day.value)}
              className="mb-2"
            />
          ))}
          {errors?.num_of_days && (
            <Form.Group className="mb-4 position-relative">
              <Form.Control.Feedback className="px-3 d-block" type="invalid">
                <FormattedMessage id="error.num_of_days" />
              </Form.Control.Feedback>
            </Form.Group>
          )}
        </Col> */}

        <Col md={6}>
          <div className="mb-3">
            <Form.Label className="fw-bold" style={{ fontWeight: 500 }}>
              <FormattedMessage id="timings" />
            </Form.Label>
          </div>
          {timingOptions.map((time, idx) => (
            <Form.Check
              key={idx}
              type="radio"
              name="timing"
              id={`timing_${time.label}`}
              label={time.label}
              checked={
                formData.attending_times?.[0]?.time ===
                `${time.value} - ${time.end}`
              }
              onChange={() => handleTimeChange(time.value, time.end)}
              className="mb-2"
            />
          ))}
          {errors?.attending_times && (
            <Form.Group className="mb-4 position-relative">
              <Form.Control.Feedback className="px-3 d-block" type="invalid">
                <FormattedMessage id="error.attending_times" />
              </Form.Control.Feedback>
            </Form.Group>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RequirementsSelector;
